import { loginUser, logoutUser, getCurrentUser, getUserMandanten } from './api';

const USE_MOCK_API = process.env.REACT_APP_USE_MOCK_API === 'true';

// Mock Users für Development
const MOCK_USERS = [
    {
        id: 1,
        username: 'admin',
        email: 'admin@regentra.de',
        password: 'admin123',
        name: 'Admin User',
        role: 'admin'
    },
    {
        id: 2,
        username: 'user',
        email: 'user@regentra.de',
        password: 'user123',
        name: 'Test User',
        role: 'user'
    },
    {
        id: 3,
        username: 'ameera',
        email: 'ameera@regentra.de',
        password: 'ameera123',
        name: 'Ameera',
        role: 'user'
    }
];

// Simulate API delay
const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));

// Mock Auth Service
const mockAuthService = {
    login: async (credentials) => {
        await delay(500);

        const user = MOCK_USERS.find(
            u => (u.username === credentials.username || u.email === credentials.username)
                && u.password === credentials.password
        );

        if (!user) {
            throw new Error('Ungültige Anmeldedaten');
        }

        const token = btoa(`${user.id}:${Date.now()}`);
        const { password, ...userData } = user;

        return {
            success: true,
            token,
            user: userData
        };
    },

    logout: async () => {
        await delay(200);
        return { success: true };
    },

    getCurrentUser: async () => {
        await delay(300);

        const token = localStorage.getItem('authToken');
        if (!token) {
            throw new Error('Not authenticated');
        }

        try {
            const decoded = atob(token);
            const userId = parseInt(decoded.split(':')[0]);
            const user = MOCK_USERS.find(u => u.id === userId);

            if (!user) {
                throw new Error('User not found');
            }

            const { password, ...userData } = user;
            return userData;
        } catch (error) {
            throw new Error('Invalid token');
        }
    },

    forgotPassword: async (email) => {
        await delay(1000);

        const user = MOCK_USERS.find(u => u.email === email);
        if (!user) {
            throw new Error('Email nicht gefunden');
        }

        return {
            success: true,
            message: 'Password reset link sent to email'
        };
    },

    resetPassword: async (token, newPassword) => {
        await delay(500);

        return {
            success: true,
            message: 'Password successfully reset'
        };
    }
};

// Real Auth Service - verwendet die API-Funktionen
const realAuthService = {
    login: async (credentials) => {
        const result = await loginUser(credentials);
        if (!result.success) {
            // Erstelle Error-Objekt mit der Backend-Fehlermeldung
            const error = new Error(result.error);
            error.status = result.status;
            throw error;
        }
        return result; // { success: true, token, user }
    },

    logout: async () => {
        const result = await logoutUser();
        if (!result.success) {
            throw new Error(result.error || 'Logout fehlgeschlagen');
        }
        return result;
    },

    getCurrentUser: async () => {
        const result = await getCurrentUser();
        if (!result.success) {
            throw new Error(result.error || 'Benutzer konnte nicht geladen werden');
        }
        return result.data;
    },

    forgotPassword: async (email) => {
        // TODO: Implementiere forgot password mit Backend
        throw new Error('Forgot password noch nicht implementiert');
    },

    resetPassword: async (token, newPassword) => {
        // TODO: Implementiere reset password mit Backend
        throw new Error('Reset password noch nicht implementiert');
    },

    // Neue Funktion für Mandanten
    getUserMandanten: async () => {
        const result = await getUserMandanten();
        if (!result.success) {
            throw new Error(result.error || 'Mandanten konnten nicht geladen werden');
        }
        return result.data;
    }
};

const authService = USE_MOCK_API ? mockAuthService : realAuthService;

export default authService;